import GoogleMap from "./GoogleMap";
import FacilitiesExaminations from "./FacilitiesExaminations";

/**
 * FacilityDetails
 * Handles all JS stuff for facilities overview page
 */
export default class FacilityDetails {

    // constructor
    constructor(selector) {

        let _this = this;
        this.$plugin = $(selector);
        this.googleMapBuilded = false;
        this.historyFilter = null;
        this.plannedFilter = null;
        this.criticalFilter = null;

        // cancel if non existing element
        if (this.$plugin.length === 0) {
            return false;
        }

        // get count of examinations and show it in frontend
        _this.getExaminationsInfo();

        this.initialLoad();

        // check router event
        window.addEventListener("router", function (e) {

            // routing switch
            switch (e.detail.path) {
                case '#!/0':
                    _this.changeTab(true);
                    break;
                case '#!/1-0':
                    _this.examinationsHistory();
                    _this.changeMapVisibility(false);
                    break;
                case '#!/1-1':
                    _this.examinationsPlanned();
                    break;
                case '#!/1-2':
                    _this.examinationsCritical();
                    break;
                case '#!/2-0':
                    _this.changeTab();
                    break;
                case '#!/2-2':
                    _this.changeTab();
                    break;
            }
        });
    }


    /**
     * examination info for counting results
     */
    getExaminationsInfo() {
        let vm = this;
        const xhrUrl = this.$plugin.find('[data-tncp-facilitydetail-count-xhr]').data('tncp-facilitydetail-count-xhr');
        let $historicalElement = vm.$plugin.find('[data-tncp-facilitydetail-count="historical"]');
        let $plannedElement = vm.$plugin.find('[data-tncp-facilitydetail-count="planned"]');
        let $criticalResultElement = vm.$plugin.find('[data-tncp-facilitydetail-count="criticalResult"]');

        $historicalElement.hide();
        $plannedElement.hide();
        $criticalResultElement.hide();

        window.xhrRequest({
            url: xhrUrl,
            method: 'GET'
        }).then((response) => {
            if (response.data.historical) {
                let result = `(${response.data.historical})`;
                $historicalElement.html(result).fadeIn(300);
            }
            if (response.data.planned) {
                let result = `(${response.data.planned})`;
                $plannedElement.html(result).fadeIn(300);
            }
            if (response.data.criticalResult) {
                let result = `(${response.data.criticalResult})`;
                $criticalResultElement.html(result).fadeIn(300);
            }
        }).catch((response) => {

        });
    }


    /**
     * examinationsHistory
     * new instance of FacilitiesExaminations if not exists
     */
    examinationsHistory() {
        if (this.historyFilter instanceof FacilitiesExaminations === false) {
            this.historyFilter = new FacilitiesExaminations('[data-tncp-plugin=FacilitiesExaminationsHistory]');
        }
    }

    /**
     * examinationsPlanned
     * new instance of FacilitiesExaminations if not exists
     */
    examinationsPlanned() {
        if (this.plannedFilter instanceof FacilitiesExaminations === false) {
            this.plannedFilter = new FacilitiesExaminations('[data-tncp-plugin=FacilitiesExaminationsPlanned]');
        }
    }

    /**
     * examinationsCritical
     * new instance of FacilitiesExaminations if not exists
     */
    examinationsCritical() {
        if (this.criticalFilter instanceof FacilitiesExaminations === false) {
            this.criticalFilter = new FacilitiesExaminations('[data-tncp-plugin=FacilitiesExaminationsCritical]');
        }
    }

    /**
	 * this script is loaded on pageload
	 * to get information like title
     */
    initialLoad() {
    	let vm = this;
        let $dynamicElement = this.$plugin.find('[data-tncp-tabs-content-id="0"] [data-tncp-xhr]');
        window.xhrRequest({
            url: $dynamicElement.data('tncp-xhr')
        }).then((response) => {
            vm.$plugin.find('[data-tncp-facilityDetails-title]').html(response.data.title);
        });
    }

    /**
     * This function is called on tab change by router event
     * @param showMapInTab
     */
    changeTab(showMapInTab = false) {
        let vm = this;
        // Map is not builded yet or not given at all
        vm.changeMapVisibility(showMapInTab);
        vm.loadData(showMapInTab);
    }

    /**
     * Show or hide google map
     * @param showMapInTab
     */
    changeMapVisibility(showMapInTab) {
        let vm = this;
        if (this.googleMapBuilded && showMapInTab) {
            vm.googlemap.enable();
        } else if (this.googleMapBuilded) {
            vm.googlemap.disable();
        }
    }

    // on contactform submit
    contactForm() {
        let vm = this;
        vm.$plugin.find('#modal_facilitycontactform form').submit(function(event) {
            const $formEl = $(this);
            let serializedData = $formEl.serialize();
            $formEl.find('[data-facilitycontactform-section="error"]').hide();
            vm.disableForm($formEl);
            vm.request = window.xhrRequest({
                url: $formEl.attr('action'),
                method: 'POST',
                data: serializedData
            });
            vm.request.then(() => {
                $formEl.find('[data-facilitycontactform-section="success"]').show();
                $formEl.find('[data-facilitycontactform-section="form"]').hide();
            }).catch((e) =>{
                $formEl.find('[data-facilitycontactform-section="error"]').show();

            }).then(() => {
                vm.disableForm($formEl, false);
            });
            event.preventDefault();
        });
    }

    // disable all form fields
    disableForm($form, disable = true) {
        let $selectors = $form.find('button, input, select, textarea');
        if (disable === true) {
            $selectors.attr('disabled', true);
        } else {
            $selectors.removeAttr('disabled');
        }
    }

    // synchronize values and submit ob change
    synchronizeValues(selector) {
        let vm = this;
        $(selector).change(function() { // listen on change of selector
            let $vm = $(this); // this jquery obj
            $(selector).val($vm.val()); // seems weird, but changes the values of all form elements with the same selector
            vm.getResults();
        });
    }

    /**
	 *
     * @param showMapInTab
     * @param routeId
     */
    loadData(showMapInTab, routeId = '') {
        let vm = this;
        if (routeId === '') {
            routeId = window.tncpRouter.getRoute();
        }
        let $dynamicElement = this.$plugin.find('[data-tncp-tabs-content-id="' + routeId + '"] [data-tncp-xhr]');
        let xhrPath = $dynamicElement.data('tncp-xhr');
        vm.request = window.xhrRequest({
            url: xhrPath
        }).then((response) => {
            $dynamicElement.html(response.data.content);
            if (showMapInTab) {
                vm.createGoogleMap();
            }

            $('.js-popup-link--inline').magnificPopup({
                type:'inline',
                midClick: true
            });

            vm.contactForm();
            $('html').on('click', '[data-facilitycontactform-facility-id]', function() {

                // set values for modal
                $('[data-facilitycontactform-title-val]').text($(this).data('facilitycontactformTitle'));
                $('[data-facilitycontactform-facility-id-val]').val($(this).data('facilitycontactformFacilityId'));
                $('[data-facilitycontactform-facility-type-val]').val($(this).data('facilitycontactformFacilityType'));
                // initial behaviour on link clicking for modal
                $(document).find('[data-facilitycontactform-section="form"]').show();
                $(document).find('[data-facilitycontactform-section="success"]').hide();
                $(document).find('[data-facilitycontactform-section="error"]').hide();
                $(document).find('[name="tx_tuevnordcustomerportal_api[message]"]').val('');
            });
        });
    }

    createGoogleMap() {
        let vm = this;

        // Create Google Map if not already builded
        if (!vm.googleMapBuilded) {
            vm.googlemap = new GoogleMap('[data-google-map]');
            vm.googleMapBuilded = true;
            vm.changeMapVisibility(true);
        }
    }
}